// extracted by css-extract-rspack-plugin
export default {"filterReplacement":"B6elGPVBvpI0urP_","qreport_wrapper":"RQSIpYuR3oI5EdxK","filter":"AmlONouPM7UTV6Fo","filterTitle":"XpFTqBWvQ9wFYnmQ","not_data":"q2GqlTGM6Ef9ZmV3"};